/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentSummariesControllerFindLatestByTypeQueryResponse, DocumentSummariesControllerFindLatestByTypePathParams, DocumentSummariesControllerFindLatestByTypeQueryParams, DocumentSummariesControllerFindLatestByType400, DocumentSummariesControllerFindLatestByType401, DocumentSummariesControllerFindLatestByType403, DocumentSummariesControllerFindLatestByType404 } from "../../models/documentSummariesController/DocumentSummariesControllerFindLatestByType";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentSummariesControllerFindLatestByType } from "../../clients/document-summariesService/documentSummariesControllerFindLatestByType";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentSummariesControllerFindLatestByTypeQueryKey = (documentId: DocumentSummariesControllerFindLatestByTypePathParams["documentId"], summaryType: DocumentSummariesControllerFindLatestByTypePathParams["summaryType"], params: DocumentSummariesControllerFindLatestByTypeQueryParams = {}) => [{
  url: '/api/v1/documents/:documentId/summaries/latest/:summaryType',
  params: {
    documentId: documentId,
    summaryType: summaryType
  }
}, ...(params ? [params] : [])] as const;
export type DocumentSummariesControllerFindLatestByTypeQueryKey = ReturnType<typeof documentSummariesControllerFindLatestByTypeQueryKey>;
export function documentSummariesControllerFindLatestByTypeQueryOptions(documentId: DocumentSummariesControllerFindLatestByTypePathParams["documentId"], summaryType: DocumentSummariesControllerFindLatestByTypePathParams["summaryType"], params?: DocumentSummariesControllerFindLatestByTypeQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentSummariesControllerFindLatestByTypeQueryKey(documentId, summaryType, params);
  return queryOptions<DocumentSummariesControllerFindLatestByTypeQueryResponse, ResponseErrorConfig<DocumentSummariesControllerFindLatestByType400 | DocumentSummariesControllerFindLatestByType401 | DocumentSummariesControllerFindLatestByType403 | DocumentSummariesControllerFindLatestByType404>, DocumentSummariesControllerFindLatestByTypeQueryResponse, typeof queryKey>({
    enabled: !!(documentId && summaryType),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentSummariesControllerFindLatestByType(documentId, summaryType, params, config);
    }
  });
}

/**
 * @description Returns the most recent summary of the specified type for this document. Automatically finds the appropriate rendition based on the summary type.
 * @summary Get the latest summary by type
 * {@link /api/v1/documents/:documentId/summaries/latest/:summaryType}
 */
export function useDocumentSummariesControllerFindLatestByType<TData = DocumentSummariesControllerFindLatestByTypeQueryResponse, TQueryData = DocumentSummariesControllerFindLatestByTypeQueryResponse, TQueryKey extends QueryKey = DocumentSummariesControllerFindLatestByTypeQueryKey>(documentId: DocumentSummariesControllerFindLatestByTypePathParams["documentId"], summaryType: DocumentSummariesControllerFindLatestByTypePathParams["summaryType"], params?: DocumentSummariesControllerFindLatestByTypeQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentSummariesControllerFindLatestByTypeQueryResponse, ResponseErrorConfig<DocumentSummariesControllerFindLatestByType400 | DocumentSummariesControllerFindLatestByType401 | DocumentSummariesControllerFindLatestByType403 | DocumentSummariesControllerFindLatestByType404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentSummariesControllerFindLatestByTypeQueryKey(documentId, summaryType, params);
  const query = useQuery({
    ...documentSummariesControllerFindLatestByTypeQueryOptions(documentId, summaryType, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentSummariesControllerFindLatestByType400 | DocumentSummariesControllerFindLatestByType401 | DocumentSummariesControllerFindLatestByType403 | DocumentSummariesControllerFindLatestByType404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}